import {authStore} from '../defaults';

const getMenuItems = (router) => {
    const hasAccess = (routeCode) => {
        const categories = authStore.data.menuCategories;
        if (!categories || categories.length === 0) return true;
        return categories.find(c => c.route_codes.includes(routeCode))?.is_enabled ?? true;
    };

    return [
        {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-chart-line',
            disabled: !hasAccess('dashboard'),
            items: [
                {
                    label: 'Główne statystyki',
                    icon: 'pi pi-fw pi-chart-bar',
                    command: () => { router.push('/dashboard') }
                }
            ]
        },
        {
            label: 'Budowy',
            icon: 'pi pi-fw pi-home',
            disabled: !hasAccess('buildings'),
            items: [
                {
                    label: 'Lista budów',
                    icon: 'pi pi-fw pi-list',
                    command: () => { router.push('/buildings') }
                },
                {
                    label: 'Dodaj budowę',
                    icon: 'pi pi-fw pi-plus',
                    command: () => { router.push('/investment') }
                }
            ]
        },
        {
            label: 'Raporty',
            icon: 'pi pi-fw pi-pencil',
            disabled: !hasAccess('report'),
            items: [
                {
                    label: 'Raporty budów',
                    icon: 'pi pi-fw pi-list',
                    command: () => { router.push('/reports') }
                },
                {
                    label: 'Dodaj raport',
                    icon: 'pi pi-fw pi-plus',
                    command: () => { router.push('/report') }
                },
                {
                    label: 'Rozliczenia materiałów',
                    icon: 'pi pi-fw pi-book',
                    command: () => { router.push('/emulsion-reports') }
                }
            ]
        },
        {
            label: 'Użytkownicy',
            icon: 'pi pi-fw pi-user',
            disabled: !hasAccess('users'),
            items: [
                {
                    label: 'Lista użytkowników',
                    icon: 'pi pi-fw pi-list',
                    command: () => { router.push('/users') }
                },
                {
                    label: 'Dodaj użytkownika',
                    icon: 'pi pi-fw pi-plus',
                    command: () => { router.push('/user') }
                }
            ]
        },
        {
            label: 'Maszyny',
            icon: 'pi pi-fw pi-cog',
            disabled: !hasAccess('machines'),
            items: [
                {
                    label: 'Lista maszyn',
                    icon: 'pi pi-fw pi-list',
                    command: () => { router.push('/machines') }
                },
                {
                    label: 'Dodaj maszynę',
                    icon: 'pi pi-fw pi-plus',
                    command: () => { router.push('/machine') }
                }
            ]
        },
        {
            label: 'Asfalty',
            icon: 'pi pi-fw pi-calendar',
            disabled: !hasAccess('asphalts'),
            items: [
                {
                    label: 'Ceny asfaltów',
                    icon: 'pi pi-fw pi-money-bill',
                    command: () => { router.push('/asphalts') }
                }
            ]
        },
        {
            label: 'Zbiorniki',
            icon: 'pi pi-fw pi-box',
            disabled: !hasAccess('tanks'),
            items: [
                {
                    label: 'Lista zbiorników',
                    icon: 'pi pi-fw pi-list',
                    command: () => { router.push('/tanks') }
                },
                {
                    label: 'Dodaj zbiornik',
                    icon: 'pi pi-fw pi-plus',
                    command: () => { router.push('/tank') }
                }
            ]
        },
        {
            label: 'Stany',
            icon: 'pi pi-fw pi-chart-pie',
            disabled: !hasAccess('states'),
            items: [
                {
                    label: 'Raporty stanów',
                    icon: 'pi pi-fw pi-list',
                    command: () => { router.push('/states') }
                },
                {
                    label: 'Dodaj raport',
                    icon: 'pi pi-fw pi-plus',
                    command: () => { router.push('/state') }
                }
            ]
        }
    ];
};

export { getMenuItems }
